export const ISO8601_REGEX = {
  FULL: /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2]\d|3[0-1])T([01]\d|2[0-3]):[0-5]\d:[0-5]\d\.\d{3}Z$/,
  SIMPLE_TIME: /^([01]\d|2[0-3]):([0-5]\d)$/,
};
